'use client'

import { useLayoutEffect, useState } from 'react'
import { SearchInputField } from '@/components/Refresh/UniversalSearch/SearchInputField'
import { SITE_HEADER_SEARCH_PLACEHOLDER } from '@/components/Refresh/UniversalSearch/universalSearchDefaults'
import universalSearchClasses from '@/components/Refresh/UniversalSearch/UniversalSearch.module.css'

interface HeaderSearchFallbackProps {
    /** Text to show in the field so refresh does not flash an empty input. */
    searchQuery?: string
}

/**
 * Visual stand-in for search in server HTML. The interactive portal is not
 * available until after hydration, so this keeps the field's shape until then.
 *
 * Viewport is applied with the same `auto` CSS as UniversalSearch, not a JS
 * breakpoint, so the first paint docks on small screens and stays inline on
 * large ones.
 */
export function HeaderSearchFallback({ searchQuery }: HeaderSearchFallbackProps) {
    const [isVisible, setIsVisible] = useState(true)

    useLayoutEffect(() => {
        setIsVisible(false)
    }, [])

    if (!isVisible) return null

    return (
        <div className={`${universalSearchClasses.root} ${universalSearchClasses.autoPlacement}`}>
            <div className={universalSearchClasses.collapsedTrigger}>
                <SearchInputField
                    value={searchQuery ?? ''}
                    placeholder={SITE_HEADER_SEARCH_PLACEHOLDER}
                    onChange={() => undefined}
                    presentationOnly
                />
            </div>
        </div>
    )
}
